import { isNewUser } from '../../utils';

const useNewUser = () => {
  return isNewUser();
};

export default useNewUser;
